import { render, staticRenderFns } from "./tab-one.vue?vue&type=template&id=e0ac945c&"
import script from "./tab-one.vue?vue&type=script&lang=ts&"
export * from "./tab-one.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports